export default __webpack_public_path__ + "static/media/reactTable.3b010fb6.png";